import { render, staticRenderFns } from "./productMetaDataUpdate.vue?vue&type=template&id=2e1e7b5f"
import script from "./productMetaDataUpdate.vue?vue&type=script&lang=js"
export * from "./productMetaDataUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports